import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID) {
    serviceOrder(id: $id, filter: { includeDeleted: true }) {
      id
      name
      parentId
      yearlyId
      startDate
      endDate
      deleted
      enabled
      insertedAt
      updatedAt
      scheduling
      description
      resumeToken
      slaExpiresAt
      executionToken
      address {
        search
        complement
      }
      documents {
        id
        src
        type
      }
      status {
        id
        name
        label
        color
      }
      user {
        id
        name
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      place {
        id
        name
        resume
        type
        placeLevelIds
      }
      asset {
        id
        name
        type {
          id
          name
        }
      }
      checklist {
        id
        name
      }
      fieldValues {
        id
        value
        field {
          id
          name
          type
          configuration
          options {
            id
            name
            reference
            ordination
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children }) => {
  const { data: id } = useCurrentModal()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
